import { render, staticRenderFns } from "./customGroupList.vue?vue&type=template&id=5f379506&scoped=true"
import script from "./customGroupList.vue?vue&type=script&lang=js"
export * from "./customGroupList.vue?vue&type=script&lang=js"
import style0 from "./customGroupList.vue?vue&type=style&index=0&id=5f379506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f379506",
  null
  
)

export default component.exports